// @flow

export const scrollTop = () => {
  const { body } = document;
  const { documentElement } = document;
  if (body) body.scrollTop = 0; // For Safari
  if (documentElement) documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};
